import React, { useEffect, useState } from 'react';

import Cookies from 'js-cookie';
import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

export const useStyles = Mui.makeStyles(theme => ({
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: theme.palette.primary.main,
  },
  cardHeader: {
    width: '100%',
  },
  cardHeaderContent: {
    maxWidth: '100%',
    overflow: 'hidden',
  },
  cardHeaderTitle: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
  dialogActions: {
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3),
  },
}));

function Notification({ cookieProperty, title, titleTypographyProps, children, ...restProps }) {
  // Hooks
  const classes = useStyles();

  // States
  const [open, setOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  // Actions
  const handleClose = () => {
    if (dontShowAgain) {
      Cookies.set(cookieProperty, 'true');
    }
    setOpen(false);
  };

  // Effects
  useEffect(() => {
    const value = Cookies.get(cookieProperty);
    if (!value) {
      setOpen(true);
    }
  }, [cookieProperty]);

  if (!open) {
    return null;
  }

  return (
    <Mui.Dialog
      transitionDuration={{ enter: 250, exit: 150 }}
      TransitionComponent={Mui.Grow}
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      {...restProps}>
      <Mui.CardHeader
        avatar={
          <Mui.Avatar className={classes.avatar}>
            <Mui.Icon color="inherit" fontSize="inherit">
              new_releases
            </Mui.Icon>
          </Mui.Avatar>
        }
        action={
          <Mui.IconButton aria-label="close" onClick={handleClose}>
            <Mui.Icon>close</Mui.Icon>
          </Mui.IconButton>
        }
        title={title}
        titleTypographyProps={{
          variant: 'h5',
          noWrap: true,
          ...titleTypographyProps,
        }}
        classes={{
          root: classes.cardHeader,
          content: classes.cardHeaderContent,
          title: classes.cardHeaderTitle,
        }}
      />
      <Mui.DialogContent>
        <Mui.DialogContentText variant="body1" component="div">
          {children}
        </Mui.DialogContentText>
      </Mui.DialogContent>
      <Mui.DialogActions
        classes={{
          root: classes.dialogActions,
        }}>
        <Mui.FormControlLabel
          control={
            <Mui.Checkbox
              name="dontShowAgain"
              value={dontShowAgain}
              onClick={() => setDontShowAgain(true)}
            />
          }
          label={<Mui.Typography variant="subtitle2">Não exibir novamente</Mui.Typography>}
        />
        <Mui.Button variant="outlined" color="secondary" size="large" onClick={handleClose}>
          Fechar
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
}

Notification.propTypes = {
  cookieProperty: PropTypes.string,
  title: PropTypes.string,
  titleTypographyProps: PropTypes.object,
  startOpen: PropTypes.bool,
  children: PropTypes.any,
};

export default Notification;
